import api from "@/lib/axios";

const endPoint = "/roles";


export default {
    getRoles: async () => {
        try {
          const response = await api.get(endPoint);
          return response.data;
        } catch (error) {
          throw new Error("Failed to fetch roles: " + error.message);
        }
      },

};